/* ============================================================
   EXALLAXE · /collections · JS de filtragem e drawer mobile
   ============================================================
   v2 (24-jun-2026): SINGLE-SELECT. Apenas 1 Vilao ativo por vez.
   Clicar em outro troca a selecao. Clicar no ativo desliga (volta a "tudo").
   Emite evento 'afericao:filter-change' que a Section 4 escuta.
   Cria drawer mobile via JS.
   ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // ESTADO GLOBAL DOS FILTROS
  // ============================================================
  const filtrosAtivos = new Set();

  // ============================================================
  // EMITIR EVENTO DE MUDANÇA DE FILTRO
  // ============================================================
  function emitirFilterChange() {
    document.dispatchEvent(new CustomEvent('afericao:filter-change', {
      detail: {
        vilaos_ativos: Array.from(filtrosAtivos)
      }
    }));
  }

  // ============================================================
  // APLICAR FILTRO NOS CARDS (LISTENER)
  // ============================================================
  document.addEventListener('afericao:filter-change', function(e) {
    const ativos = e.detail.vilaos_ativos || [];
    const cards = document.querySelectorAll('.card-afericao');

    cards.forEach(function(card) {
      const vilaoCard = card.dataset.vilao || '';
      const visivel = ativos.length === 0 || ativos.indexOf(vilaoCard) !== -1;
      card.dataset.hidden = visivel ? 'false' : 'true';
    });

    // Atualiza contador mobile
    const mobileCount = document.querySelector('[data-filtros-ativos]');
    if (mobileCount) {
      mobileCount.textContent = ativos.length;
      mobileCount.dataset.filtrosAtivos = ativos.length;
    }

    // Atualiza ficha dinamica com a microcopy do vilao ativo (single-select)
    atualizarFicha(ativos);
  });

  // ============================================================
  // DISPLAY DINAMICO — desktop (ficha unica) + mobile (nome + microcopy)
  // Escreve em ambos; CSS controla qual aparece por viewport.
  // ============================================================
  function atualizarFicha(ativos) {
    const deskEl  = document.querySelector('.filtros-desktop-ficha');
    const nomeEl  = document.querySelector('.filtros-nome-texto');
    const microEl = document.querySelector('.filtros-micro-texto');

    const fichaDefault = deskEl  ? (deskEl.dataset.fichaDefault || '')  : '';
    const nomeDefault  = nomeEl  ? (nomeEl.dataset.nomeDefault || '')   : '';
    const microDefault = microEl ? (microEl.dataset.microDefault || '') : '';

    // Sem selecao: defaults, remove classes de cor.
    if (!ativos || ativos.length === 0) {
      if (deskEl)  { deskEl.textContent  = fichaDefault; deskEl.classList.remove('is-ativo', 'is-aferitiva'); }
      if (nomeEl)  { nomeEl.textContent  = nomeDefault;  nomeEl.classList.remove('is-ativo', 'is-aferitiva'); }
      if (microEl) { microEl.textContent = microDefault; microEl.classList.remove('is-ativo', 'is-aferitiva'); }
      return;
    }

    // Single-select.
    const vilaoId = ativos[0];
    const btn = document.querySelector('.filtro-vilao[data-vilao-id="' + vilaoId + '"]');
    if (!btn) return;

    const num   = btn.dataset.num || '';
    const nome  = btn.dataset.nome || '';
    const count = btn.dataset.count || '0';
    const micro = btn.dataset.microcopy || '';
    const ehAferitiva = (vilaoId === 'aferitiva');

    // Desktop: ficha unica = microcopy do vilao
    if (deskEl) {
      deskEl.textContent = micro;
      deskEl.classList.toggle('is-aferitiva', ehAferitiva);
      deskEl.classList.toggle('is-ativo', !ehAferitiva);
    }
    // Mobile linha 1: "N · NOME (count)"
    if (nomeEl) {
      nomeEl.textContent = num + ' · ' + nome + ' (' + count + ')';
      nomeEl.classList.toggle('is-aferitiva', ehAferitiva);
      nomeEl.classList.toggle('is-ativo', !ehAferitiva);
    }
    // Mobile linha 2: microcopy
    if (microEl) {
      microEl.textContent = micro;
      microEl.classList.toggle('is-aferitiva', ehAferitiva);
      microEl.classList.toggle('is-ativo', !ehAferitiva);
    }
  }

  // ============================================================
  // TOGGLE DE BOTÃO DE VILÃO (SINGLE-SELECT)
  // ============================================================
  // Apenas 1 Vilao ativo por vez. Clicar em outro troca a selecao.
  // Clicar no Vilao ja ativo desliga (volta a mostrar tudo).
  function toggleVilao(button) {
    const vilaoId = button.dataset.vilaoId;
    if (!vilaoId) return;

    const jaAtivo = button.getAttribute('aria-pressed') === 'true';

    // Limpa toda a selecao e desmarca todos os botoes (desktop + drawer).
    filtrosAtivos.clear();
    document.querySelectorAll('.filtro-vilao').forEach(function(btn) {
      btn.setAttribute('aria-pressed', 'false');
    });

    // Se o clicado nao estava ativo, ativa-o (single). Se ja estava, fica tudo limpo.
    if (!jaAtivo) {
      filtrosAtivos.add(vilaoId);
      document.querySelectorAll('[data-vilao-id="' + vilaoId + '"]').forEach(function(btn) {
        btn.setAttribute('aria-pressed', 'true');
      });
    }

    emitirFilterChange();
  }

  // ============================================================
  // LIMPAR TODOS OS FILTROS
  // ============================================================
  function limparFiltros() {
    filtrosAtivos.clear();
    document.querySelectorAll('.filtro-vilao').forEach(function(btn) {
      btn.setAttribute('aria-pressed', 'false');
    });
    emitirFilterChange();
  }

  // ============================================================
  // DRAWER MOBILE
  // ============================================================
  let drawerEl = null;
  let drawerOverlayEl = null;
  let drawerOpen = false;

  function criarDrawer() {
    if (drawerEl) return;

    // Clona o conteúdo da sticky bar para o drawer
    const sticky = document.querySelector('.filtros-sticky .filtros-container');
    if (!sticky) return;

    // Overlay
    drawerOverlayEl = document.createElement('div');
    drawerOverlayEl.className = 'filtros-drawer-overlay';
    drawerOverlayEl.setAttribute('aria-hidden', 'true');
    drawerOverlayEl.addEventListener('click', fecharDrawer);
    document.body.appendChild(drawerOverlayEl);

    // Drawer
    drawerEl = document.createElement('aside');
    drawerEl.className = 'filtros-drawer';
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-modal', 'true');
    drawerEl.setAttribute('aria-label', 'Filtrar por mecanismo de captura');

    // Botão fechar
    const btnFechar = document.createElement('button');
    btnFechar.type = 'button';
    btnFechar.className = 'filtros-drawer-close';
    btnFechar.setAttribute('aria-label', 'Fechar filtros');
    btnFechar.innerHTML = '✕';
    btnFechar.addEventListener('click', fecharDrawer);
    drawerEl.appendChild(btnFechar);

    // Clone do conteúdo
    const cloneConteudo = sticky.cloneNode(true);
    drawerEl.appendChild(cloneConteudo);

    document.body.appendChild(drawerEl);

    // Re-anexa listeners aos botões clonados
    drawerEl.querySelectorAll('.filtro-vilao').forEach(function(btn) {
      btn.addEventListener('click', function() { toggleVilao(this); });
    });
    const btnLimpar = drawerEl.querySelector('[data-action="filtros-limpar"]');
    if (btnLimpar) {
      btnLimpar.addEventListener('click', limparFiltros);
    }
  }

  function abrirDrawer() {
    criarDrawer();
    if (!drawerEl) return;
    drawerOpen = true;
    drawerEl.dataset.open = 'true';
    drawerOverlayEl.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    // Foco no primeiro botão para acessibilidade
    const primeiroBtn = drawerEl.querySelector('.filtros-drawer-close');
    if (primeiroBtn) primeiroBtn.focus();
  }

  function fecharDrawer() {
    if (!drawerEl) return;
    drawerOpen = false;
    drawerEl.dataset.open = 'false';
    drawerOverlayEl.dataset.open = 'false';
    document.body.style.overflow = '';
    // Devolve foco ao botão de abrir
    const btnAbrir = document.querySelector('[data-action="filtros-drawer-open"]');
    if (btnAbrir) btnAbrir.focus();
  }

  // ============================================================
  // ESCUTAR TECLA ESC PARA FECHAR DRAWER
  // ============================================================
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerOpen) fecharDrawer();
  });

  // ============================================================
  // FADE SEQUENCIAL DO BLOCO DIDEROT (Section 5)
  // ============================================================
  function initDiderot() {
    var wrapper = document.querySelector('.list-diderot-wrapper');
    if (!wrapper) return;

    // Marca que o JS esta ativo: ativa o estado inicial (opacity 0).
    // Sem JS, o texto permanece visivel (progressive enhancement).
    wrapper.classList.add('diderot-js');

    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Sem suporte a observer ou com reduced-motion: revela imediato, sem stagger.
    if (prefersReduced || !('IntersectionObserver' in window)) {
      wrapper.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    observer.observe(wrapper);
  }

  // ============================================================
  // INICIALIZAÇÃO
  // ============================================================
  function init() {
    // Listeners dos botões de Vilão (sticky)
    document.querySelectorAll('.filtros-sticky .filtro-vilao').forEach(function(btn) {
      btn.addEventListener('click', function() { toggleVilao(this); });
    });

    // Listener dos botoes limpar (desktop + mobile — ha dois no DOM)
    document.querySelectorAll('.filtros-sticky [data-action="filtros-limpar"]').forEach(function(btn) {
      btn.addEventListener('click', limparFiltros);
    });

    // Listener do botão mobile que abre drawer
    const btnMobileToggle = document.querySelector('[data-action="filtros-drawer-open"]');
    if (btnMobileToggle) {
      btnMobileToggle.addEventListener('click', abrirDrawer);
    }

    // Fade sequencial do bloco Diderot
    initDiderot();
  }

  // Roda init quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
